













































































































































import { Component, Vue } from 'vue-property-decorator';
import ProjectChooser from '@/components/utils/ProjectChooser.vue';
import { Getter } from 'vuex-class';
import type { Project } from '@/models/project';
import { ViewType } from '@/components/prine/enums/ViewType';
import TradesToDoWizard from '@/components/toDoWizard/trade/TradesToDoWizard.vue';
import ProjectViewTypeSelector from '@/components/projects/fields/ProjectViewTypeSelector.vue';
import PmToDoWizard from '@/components/toDoWizard/pm/PmToDoWizard.vue';
import ProjectViewTradesGrid from '@/components/projects/grid/ProjectViewTradesGrid.vue';
import ProjectViewPMGrid from '@/components/projects/grid/ProjectViewPMGrid.vue';
import ProjectViewTradesList from '@/components/projects/list/ProjectViewTradesList.vue';
import ProjectViewPMList from '@/components/projects/list/ProjectViewPMList.vue';
import type { Company } from '@/models/company';
import DynamicToDoWizard from '@/components/toDoWizard/x/XToDoWizard.vue';
import ProjectViewXList from '@/components/projects/list/ProjectViewXList.vue';
import ProjectViewXGrid from '@/components/projects/grid/ProjectViewXGrid.vue';
import XToDoWizard from '@/components/toDoWizard/x/XToDoWizard.vue';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';
import ProjectOrderTable from '@/components/projects/ProjectOrderTable.vue';

@Component({
    name: 'ProjectView',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        ProjectOrderTable,
        XToDoWizard,
        ProjectViewPMList,
        ProjectViewTradesList,
        ProjectChooser,
        TradesToDoWizard,
        ProjectViewTypeSelector,
        PmToDoWizard,
        ProjectViewTradesGrid,
        ProjectViewPMGrid,
        DynamicToDoWizard,
        ProjectViewXGrid,
        ProjectViewXList,
    },
})
export default class ProjectView extends Vue {
    private ViewType = ViewType;
    private viewState: ViewType = ViewType.Grid;

    @Getter('project/selectedProject') private selectedProject: Project;
    @Getter('account/company') private company: Company;
    @Getter('utils/currentLocale') private currentLocale: string;
    @Getter('account/companyProcessName') private companyProcessName: string;
    @Getter('account/companyProcessTabTitle') private companyProcessTabTitle: string;

    get language() {
        return this.$i18n.locale;
    }

    get activeTab() {
        return this.$store.getters['project/activeTab'];
    }

    set activeTab(value) {
        this.$store.commit('project/setActiveTab', value);
    }
}
